import AlgoliaFeedVertical from "./AlgoliaFeedVertical";
import MixedFeedVertical from "./MixedFeedVertical";
import AlgoliaFeedCategory from "./AlgoliaFeedCategory";
import MixedFeedCategory from "./MixedFeedCategory";
import AlgoliaFeedNews from "./AlgoliaFeedNews";
import MixedFeedNews from "./MixedFeedNews";
import AlgoliaFeedNewsAnnouncements from "./AlgoliaFeedNewsAnnouncements";
import MixedFeedNewsAnnouncements from "./MixedFeedNewsAnnouncements";
import MixedFeedAuthor from "./MixedFeedAuthor";
import MixedFeedMultiVertical from "./MixedFeedMultiVertical";
import MixedRecommendedWidget from "./MixedRecommendedWidget";

export default class Headless {
    static init() {
        const algoliaFeedVerticalEl = document.querySelector("[data-feed-component-vertical-algolia]");
        if (algoliaFeedVerticalEl) {
            AlgoliaFeedVertical.create(algoliaFeedVerticalEl);
        }

        const mixedFeedVerticalEl = document.querySelector("[data-feed-component-vertical-mixed]");
        if (mixedFeedVerticalEl) {
            MixedFeedVertical.create(mixedFeedVerticalEl);
        }

        const algoliaFeedCategoryEl = document.querySelector("[data-feed-component-category-algolia]");
        if (algoliaFeedCategoryEl) {
            AlgoliaFeedCategory.create(algoliaFeedCategoryEl);
        }

        const mixedFeedCategoryEl = document.querySelector("[data-feed-component-category-mixed]");
        if (mixedFeedCategoryEl) {
            MixedFeedCategory.create(mixedFeedCategoryEl);
        }

        const algoliaFeedNewsEl = document.querySelector("[data-feed-component-news-algolia]");
        if (algoliaFeedNewsEl) {
            AlgoliaFeedNews.create(algoliaFeedNewsEl);
        }

        //data-feed-component-news-mixed
        const mixedFeedNewsEl = document.querySelector("[data-feed-component-news-mixed]");
        if (mixedFeedNewsEl) {
            MixedFeedNews.create(mixedFeedNewsEl);
        }

        // data-feed-component-news-announcements-algolia
        const algoliaFeedNewsAnnouncementsEl = document.querySelector("[data-feed-component-news-announcements-algolia]");
        if (algoliaFeedNewsAnnouncementsEl) {
            AlgoliaFeedNewsAnnouncements.create(algoliaFeedNewsAnnouncementsEl);
        }

        const mixedFeedNewsAnnouncementsEl = document.querySelector("[data-feed-component-news-announcements-mixed]");
        if (mixedFeedNewsAnnouncementsEl) {
            MixedFeedNewsAnnouncements.create(mixedFeedNewsAnnouncementsEl);
        }

        // data-feed-component-author-mixed
        const mixedFeedAuthorEl = document.querySelector("[data-feed-component-author-mixed]");
        if (mixedFeedAuthorEl) {
            MixedFeedAuthor.create(mixedFeedAuthorEl);
        }

        //data-feed-multi-component-vertical-mixed
        const mixedFeedMultiVerticalEl = document.querySelector("[data-feed-multi-component-vertical-mixed]");
        if (mixedFeedMultiVerticalEl) {
            MixedFeedMultiVertical.create(mixedFeedMultiVerticalEl);
        }

        const mixedRecommendedWidgetEl = document.querySelector("[data-recommended-widget]");
        if (mixedRecommendedWidgetEl) {
            MixedRecommendedWidget.create(mixedRecommendedWidgetEl);
        }
    }
}
